var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373635",
    d: "M20.82 1.501H3.293c-.957 0-1.794.689-1.794 1.635v17.565c0 .952.837 1.8 1.794 1.8h17.521c.963 0 1.685-.854 1.685-1.8V3.136c.006-.946-.722-1.635-1.68-1.635M8.009 19.006H5V9.652H8.01zm-1.4-10.777h-.022C5.624 8.23 5 7.513 5 6.616c0-.914.64-1.614 1.624-1.614s1.587.695 1.608 1.614c0 .897-.624 1.613-1.625 1.613m12.395 10.777h-3.009V13.89c0-1.225-.438-2.062-1.526-2.062-.832 0-1.324.562-1.543 1.11-.082.197-.104.465-.104.739v5.328H9.814V9.652h3.008v1.301c.438-.623 1.122-1.52 2.713-1.52 1.975 0 3.469 1.301 3.469 4.108z"
  })));
};
export default SvgLinkedin;